import { createFileRoute } from '@tanstack/react-router';

import { MembersPage } from '../modules/memberships/ui/pages/MembersPage';

export const Route = createFileRoute('/_authenticated/dashboard/memberships/members/')({
  component: MembersPage,
  staticData: {
    breadcrumb: ['Memberships', 'Members'],
  },
});
